import { t } from '@lingui/core/macro'
import { TextThemeUI } from '@jotta/ui/themeui'
import { RadixDialog } from '@jotta/ui/RadixDialog'
import type { RadixModalProps } from '@jotta/ui/RadixModal'
import { RadixModal } from '@jotta/ui/RadixModal'

export interface DeleteAlbumDialogProps extends RadixModalProps {
  isLoading?: boolean
  onDeleteAlbum: () => void
}

export const DeleteAlbumDialog: React.FC<DeleteAlbumDialogProps> = ({
  isLoading = false,
  onDeleteAlbum,
  ...props
}) => {
  return (
    <RadixModal {...props}>
      <RadixDialog
        title={t`DeleteAlbumButton.confirmTitle`}
        onClose={props.onClose}
        buttons={[
          {
            label: t`DeleteAlbumButton.confirmLabel`,
            loading: isLoading,
            action: onDeleteAlbum,
            type: 'destructive',
          },
          {
            action: 'close',
            label: t`Cancel`,
            type: 'outline',
          },
        ]}
      >
        <TextThemeUI variant="styles.p" sx={{ mb: 3 }}>
          {t`DeleteAlbumButton.confirmBody`}
        </TextThemeUI>
      </RadixDialog>
    </RadixModal>
  )
}
